/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolMilitaryTechIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-military-tech"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12 20.15L10.05 21.6Q9.65 21.88 9.26 21.61Q8.88 21.35 9.03 20.88L9.8 18.45L7.88 17.1Q7.47 16.82 7.61 16.36Q7.75 15.9 8.25 15.9L10.6 15.9L11.3 13.6L7.6 11.35Q7.15 11.07 6.9 10.63Q6.65 10.18 6.65 9.6L6.65 3.8Q6.65 2.67 7.41 1.91Q8.18 1.15 9.3 1.15L14.7 1.15Q15.82 1.15 16.59 1.91Q17.35 2.67 17.35 3.8L17.35 9.6Q17.35 10.2 17.11 10.68Q16.88 11.15 16.45 11.4L12.7 13.6L13.4 15.9L15.75 15.9Q16.25 15.9 16.39 16.36Q16.52 16.82 16.13 17.1L14.2 18.45L14.97 20.88Q15.13 21.35 14.74 21.61Q14.35 21.88 13.95 21.6ZM10.7 3.8L10.7 10.1L12.03 10.93L13.35 10.1L13.35 3.8Z" fill={color} />
    </svg>
  );
}
